export default __webpack_public_path__ + "static/media/LO08.2aee25b7.mp3";